import React from "react";
import { ClockCircleOutlined, InfoCircleOutlined, RetweetOutlined } from "@ant-design/icons";

const ProjectConstants = new Object();

ProjectConstants.status_data = {
    in_progress: {
      icon: <ClockCircleOutlined style={{ color: "grey" }} />,
      title: "All3D is creating",
    },
    in_review: {
      icon: <RetweetOutlined style={{ color: "grey" }} />,
      title: "In Progress",
    },
    needs_review: {
      icon: <RetweetOutlined style={{ color: "grey" }} />,
      title: "Ready for review",
    },
    ready_for_scenes: {
      icon: <RetweetOutlined style={{ color: "grey" }} />,
      title: "In Progress",
    }
  };

  export default ProjectConstants;